/**
 * @enum
 */
const ChecklistAlertTypes = Object.freeze({
	assignedPatrolWarning: 'assignedPatrolWarning',
	assignedPatrolInfo: 'assignedPatrolInfo',
	unsavedWarning: 'unsavedWarning',
});

export default ChecklistAlertTypes;
